import './CancelButton.css';

function CancelButton (props) {
    return (
        <div>
            <button className='cancel-button' onClick={props.onClickFunction}>{props.buttonText}</button>
        </div>
    )
}

export default CancelButton;